import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const InboxIcon = ({
  width = '25',
  height = '25',
  color = '#F5A623'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    style={{
      fill: color,
      width: width,
      height: height
    }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    version="1.1"
  >
    <g id="surface1">
      <path d="M 9 7 C 8.570313 7 8.1875 7.273438 8.050781 7.683594 L 2.050781 25.683594 C 2.015625 25.785156 2 25.890625 2 26 L 2 41 C 2 41.554688 2.445313 42 3 42 L 47 42 C 47.554688 42 48 41.554688 48 41 L 48 26.019531 C 48 26.011719 48 26.007813 48 26 C 48 25.890625 47.984375 25.785156 47.949219 25.683594 L 41.949219 7.683594 C 41.8125 7.273438 41.429688 7 41 7 Z M 9.71875 9 L 40.28125 9 L 45.609375 25 L 32 25 C 31.445313 25 31 25.445313 31 26 C 31 29.308594 28.308594 32 25 32 C 21.691406 32 19 29.308594 19 26 C 19 25.445313 18.554688 25 18 25 L 4.390625 25 Z "></path>
    </g>
  </IconSvg>
)

export default InboxIcon
